export default __webpack_public_path__ + "cd660ddd186491812c1db6509552aa87.svg";